import { createSlice } from "@reduxjs/toolkit";
import { addCartDonatesAPI, deleteCartDonatesAPI, editCartDonatesAPI } from "../../../api/publicApi";
import { DonationFormProps } from "../../../utils/types";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const addCartDonateSlice = createSlice({
  name: "addCartDonate",
  initialState: data,
  reducers: {
    addCartDonateSlice(state) {
      state.isLoading = true;
    },
    addCartDonateSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      if(action?.payload?.results?.token){
        typeof localStorage !=="undefined"&&localStorage.setItem("donation_id",action?.payload?.results?.token)
      }
      state.message = null;
    },
    addCartDonateSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    addCartDonateSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const addCartDonateHandler = (data:{org_id:string,amount:number}) => async (dispatch: any) => {
  try {
    dispatch(addCartDonateAction.addCartDonateSlice());
    const response: any = await addCartDonatesAPI(data);

    dispatch(addCartDonateAction.addCartDonateSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(addCartDonateAction.addCartDonateSliceFailure(e?.response?.data?.message));
    dispatch(addCartDonateAction.addCartDonateSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export const editCartDonateHandler = (donation_id:string,body:DonationFormProps) => async (dispatch: any) => {
  try {
    dispatch(addCartDonateAction.addCartDonateSlice());
    const response: any = await editCartDonatesAPI(donation_id,body);
    dispatch(addCartDonateAction.addCartDonateSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(addCartDonateAction.addCartDonateSliceFailure(e?.response?.data?.message));
    dispatch(addCartDonateAction.addCartDonateSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export const deleteCartDonateHandler = (donation_id:string) => async (dispatch: any) => {
  try {
    dispatch(addCartDonateAction.addCartDonateSlice());
    const response: any = await deleteCartDonatesAPI(donation_id);
    dispatch(addCartDonateAction.addCartDonateSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(addCartDonateAction.addCartDonateSliceFailure(e?.response?.data?.message));
    dispatch(addCartDonateAction.addCartDonateSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default addCartDonateSlice.reducer;
export const addCartDonateAction = addCartDonateSlice.actions;
